import { gql } from '@apollo/client';

export const FETCH_DATA_IMPORTERS_STEPS = gql`
    query fetchDataImportersSteps {
        facility {
            id
            configurations {
                sequences {
                    id
                    name
                    steps {
                        id
                        lastTriggerTime
                        dataImporter {
                            id
                            name
                            type
                        }
                    }
                }
            }
        }
    }
`;
